export default "__VITE_ASSET__BWqFuLlR__"